import { Dispatch } from 'redux';

const { Button } = window.Edocat.Components;
const { withStyles, CircularProgress } = window.Material;
const MuiAlert = window.labMaterial.Alert;

import Input from './Input';

import { highlightErrors, onSubmitSuccess, onSubmitError } from '../../actions/login';
import { validateForm } from '../../utils/formData';
import { Reducer } from '../../reducers';
import { LoginReducer } from '../../reducers/login';
import { ReduxComponentInterface } from 'edocatbase/Global';

interface FormProps extends LoginReducer, ReduxComponentInterface {}

const styles = (theme: any) => ({
  button: {
    width: '100%',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class Form extends React.PureComponent<FormProps> {
  private readonly form: any;

  constructor(props: FormProps) {
    super(props);

    this.form = React.createRef();

    // @ts-ignore
    window.onSubmitSuccess = this.onSubmitSuccess;
    // @ts-ignore
    window.onSubmitFailure = this.onSubmitFailure;
  }

  onSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const { actions, form } = this.props;
    const errors = validateForm(form);

    if (!errors.username && !errors.password) {
      actions.highlightErrors(errors);
      this.form.current.submit();

      // yes, it is deprecated, we know. But IE 11...
      try {
        // @ts-ignore
        window.external.AutoCompleteSaveForm(this.form.current.cloneNode(true));
      } catch (e) {
        // do nothing
      }
    } else {
      actions.highlightErrors(errors);
    }
  };

  onSubmitSuccess = () => {
    const { actions } = this.props;
    actions.onSubmitSuccess();
  };

  onSubmitFailure = () => {
    const { actions } = this.props;
    actions.onSubmitError();
  };

  render() {
    const { error, errors, processing, redirecting, classes } = this.props;

    return (
      <form
        action={`${window.Edocat.texts.appContext}/page/dologin`}
        className="Login-Form"
        method="POST"
        onSubmit={this.onSubmit}
        ref={this.form}
        target="iframe"
      >
        {error && <MuiAlert severity="error">{window.Edocat.texts['login.failed']}</MuiAlert>}
        <div className="Form-Input">
          <Input autoComplete="username" autoFocus name="username" label={window.Edocat.texts['label.username']} />
          <Input autoComplete="current-password" name="password" label={window.Edocat.texts['label.password']} type="password" />
          <input
            type="text"
            className="hidden"
            name="success"
            value={`${window.Edocat.texts.appContext}/page/success`}
          />
          <input
            type="text"
            className="hidden"
            name="failure"
            value={`${window.Edocat.texts.appContext}/page/failure`}
          />
        </div>
        <div className="Form-Row Button-Row">
          <Button
            primary
            label={window.Edocat.texts['label.login']}
            disabled={processing || errors.username || errors.password || redirecting}
            type="submit"
            className={classes.button}
            id="signInBtn"
          />
          {redirecting && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
        {/*{redirecting && <Modal />}*/}
        <div className="Copy-Info">
          <p>{window.Edocat.texts['edocat.footer.softwaredocat']}</p>
          <p>
            {window.Edocat.texts['edocat.footer.edocatlink']}{' '}
            <a href="http://www.edocat.cz" target="edocat">
              www.edocat.cz
            </a>{' '}
            {window.Edocat.texts['edocat.footer.onliolink']}{' '}
            <a href="http://www.onlio.com" target="onlio">
              www.onlio.com
            </a>
            .
          </p>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state: Reducer) => ({
  form: state.login.form,
  errors: state.login.errors,
  error: state.login.error,
  processing: state.login.processing,
  redirecting: state.login.redirecting,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ highlightErrors, onSubmitSuccess, onSubmitError }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Form));
